<div class="page-section series-form-page">
    <div class="app-l-page__navigation">
        <div
            class="app-l-page__previous"
            (click)="navigateToListingPage()"
            (keypress)="navigateToListingPage()">
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item">
                    <a
                        (click)="navigateToListingPage()"
                        (keypress)="navigateToListingPage()"
                        >Series</a
                    >
                </li>
                <li class="breadcrumbs-list-item app-l-current-page">
                    {{ title }}
                </li>
            </ul>
        </div>
    </div>
    <div class="page-section-content">
        <page-loader *ngIf="!isLoaded"></page-loader>
        <form novalidate [formGroup]="readsEditForm">
            <div id="resource-section" class="form-wrapper-80" *ngIf="isLoaded">
                <div class="lang-Btn">
                    <a
                        tabindex="0"
                        class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                        (click)="toggleField('French', 'Title')"
                        (keypress)="toggleField('French', 'Title')"
                        [class.active]="showTitleFrench"
                        >French</a
                    >
                    <a
                        tabindex="0"
                        class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                        (click)="toggleField('Spanish', 'Title')"
                        (keypress)="toggleField('Spanish', 'Title')"
                        [class.active]="showTitleSpanish"
                        >Spanish</a
                    >
                </div>
                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="titleen"
                        >Title (English)</label
                    >
                    <input
                        class="app-c-form-control"
                        id="titleen"
                        formControlName="titleen"
                        required
                        type="text" />
                    <div
                        class="error-message"
                        *ngIf="f.titleen.touched && f.titleen.errors?.required">
                        The Title (English) is required
                    </div>
                    <div
                        class="error-message"
                        *ngIf="f.titleen.errors?.maxlength">
                        The Title (English) must be 50 characters or less
                    </div>
                </div>

                <div class="app-c-form-group" *ngIf="showTitleFrench">
                    <label class="app-c-form--label" for="titlefr"
                        >Title (French)</label
                    >
                    <input
                        class="app-c-form-control"
                        id="titlefr"
                        formControlName="titlefr"
                        type="text" />
                </div>

                <div class="app-c-form-group" *ngIf="showTitleSpanish">
                    <label class="app-c-form--label" for="titlees"
                        >Title (Spanish)</label
                    >
                    <input
                        class="app-c-form-control"
                        id="titlees"
                        formControlName="titlees"
                        type="text" />
                </div>

                <div class="app-c-form-group" *ngIf="seriesPageType != 'customType'">
                    <label class="app-c-form--label" for="category" translate>Category</label>
                    <select class="app-c-form-control" id="category" formControlName="category" required>
                        <option value="">-- Select --</option>
                        <option *ngFor="let category of categoryList" [value]="category.ID">
                            {{ category.Title }}
                        </option>
                    </select>
                    <div class="error-message" *ngIf="f.category.touched && f.category.errors?.required">
                        The Category is required
                    </div>
                </div>

                <div
                    class="icon-input org-select"
                    *ngIf="seriesPageType == 'customType'">
                    <div>
                        <multiselect-autocomplete
                            placeholder="Select an organization"
                            [items]="multiSelOrgs"
                            formControlName="orgIds"
                            [formValue]="readsEditForm.value.orgIds"
                            (onSelectItems)="
                                onSelectOrgs($event)
                            "></multiselect-autocomplete>
                        <div class="error-message" *ngIf="orgError !== ''">
                            {{ orgError }}
                        </div>
                        <div
                            class="error-message"
                            *ngIf="
                                orgError === '' &&
                                f.organizationID.touched &&
                                f.organizationID.errors?.required
                            ">
                            Please select an organization
                        </div>
                    </div>
                </div>

                <div class="icon-input image-box">
                    <label for="image">
                        Background Image
                        <span class="info-title"
                            >(Max: 2MB | Format: JPG/JPEG)</span
                        >
                    </label>
                    <input
                        type="file"
                        (change)="readsImageUpload($event)"
                        #input />
                </div>
                <div
                    class="preview image-preview"
                    *ngIf="readsEditForm.value.thumbnailUrl">
                    <p>Image preview</p>
                    <img [src]="readsEditForm.value.thumbnailUrl" />
                </div>

                <div class="image-box">
                    <div class="attachments">
                        <div class="attachment">
                            <div class="icon-input">
                                <label for="audioFileUpload">
                                    Read File
                                    <span class="info-title"
                                        >(Max: 25MB | Format: PDF)</span
                                    >
                                </label>
                                <div class="file-input">
                                    <input
                                        placeholder="File Attachment"
                                        type="file"
                                        required
                                        (change)="
                                            changeAttachmentUploadListener(
                                                $event
                                            )
                                        " />
                                    <span
                                        class="app-c-spinner"
                                        *ngIf="isFileLoading"
                                        aria-label="Loading"></span>
                                </div>
                            </div>
                            <p class="red" *ngIf="fileError">{{ errors }}</p>
                            <div
                                class="preview audio-preview"
                                *ngIf="readsEditForm.value.fileUrl">
                                <label for="logo">File preview</label>
                                <a
                                    href="{{ readsEditForm.value.fileUrl }}"
                                    target="_blank">
                                    {{ readsEditForm.value.fileName }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="icon-input desclang-box">
                    <label class="app-c-checkbox">
                        <input type="checkbox" formControlName="active" />
                        <span>Active?</span>
                    </label>
                </div>
                <div class="fixed-footer">
                    <p
                        class="red"
                        *ngIf="
                            submitButtonPressed &&
                            !readsEditForm.valid &&
                            errors === ''
                        ">
                        Please check the errors
                    </p>
                    <p class="red">{{ errors }}</p>
                    <a
                        tabindex="0"
                        class="app-c-btn app-c-btn--primary app-c-btn--curve"
                        (click)="doSave()"
                        (keypress)="doSave()"
                        >Save</a
                    >
                </div>
            </div>
        </form>
    </div>
</div>
